<template>
  <div class="home" >
    <div class="page-wrapper">
      <!-- header start -->
      <header class="header">
      <!-- logo -->
      <img src="../assets/logo.png"  class="logo">
      <!-- separate line -->
      <div class="border-line"></div>
      <!-- page title -->
      <h1 class="title">EXCLUSIVE OFFER</h1>
      </header>
      <transition name="fade" :mode="'out-in'">
      <div v-if="!$root.signedUp" :key="1">
        <MainPage />
      </div>

      <div v-else :key="2">
        <Thankyou  />
      </div>
    </transition>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src
import MainPage from '@/components/MainPage.vue';
import Thankyou from '@/components/Thankyou.vue';

export default {
  name: 'home',
  components: {
    MainPage,
    Thankyou,
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
